import { Box, MenuItem, SxProps } from "@mui/material";
import { times } from "lodash";
import { ReactNode } from "react";

import { plural } from "~frontend/util/plural";

import { FormikSelect } from "./FormSelect";

const DEFAULT_OPTIONS = [
  ...[5, 10, 30].map(value => ({ value, label: `${value} minutes` })),
  ...times(24, i => ({
    value: (i + 1) * 60,
    label: plural(i + 1, "hour", "hours"),
  })),
];

export const FormikDurationField = ({
  name,
  label,
  bottomLabel,
  fullWidth,
  options = DEFAULT_OPTIONS,
  sx = {},
}: {
  name: string;
  label?: string;
  bottomLabel?: string;
  fullWidth?: boolean;
  options?: { value: number; label: string }[];
  sx?: SxProps;
}): ReactNode => {
  return (
    <Box sx={{ width: fullWidth ? "100%" : undefined }}>
      <FormikSelect
        sx={{ ...sx, width: fullWidth ? "100%" : undefined }}
        name={name}
        label={label}
        bottomLabel={bottomLabel}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </FormikSelect>
    </Box>
  );
};
